import React from 'react';

function ImportStudyUploadIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M8 2.66669V10.6667M8 2.66669L5.33333 5.33335M8 2.66669L10.6667 5.33335"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 10.6667V11.3334C3.33333 12.0698 3.93029 12.6667 4.66667 12.6667H11.3333C12.0697 12.6667 12.6667 12.0698 12.6667 11.3334V10.6667"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ImportStudyUploadIcon;
